export const MenuKeys = {
  PRODUCTS_AND_REWARDS: 'menu.shop.reward',
  REWARDS: 'menu.reward',
  SHOP_PRODUCTS: 'menu.shop',
  USER_PACKAGES: 'menu.user.packages',
  USER_COUPONS: 'menu.user.coupons',
  ADMIN_ORDER_HISTORY: 'menu.admin.order.history',
  BOOKING_MANAGEMENT: 'menu.booking.management',
  BOOKING2_MANAGEMENT: 'menu.booking2.management',
  USER_MANAGEMENT: 'menu.user.management',
  INVITE_CUSTOMER: 'menu.invite.customer',
  DASHBOARD: 'menu.dashboard.new',
  REPORT: 'menu.report',
  CONTACT_US: 'menu.contact.us',
  POINT_HISTORY: 'menu.point.history',
  BOOKING: 'menu.booking.new',
  BOOKING2: 'menu.booking2',
  DEPOSIT: 'menu.deposit',
  ORDER_HISTORY: 'menu.order.history',
  ADMIN_MANAGEMENT: 'menu.admin.management',
  ADDPOINT: 'menu.add.point',
  CUSTOMER_ADDPOINT: 'menu.addPoint.customer',
  ADD_WALLET: 'menu.addWallet',
  ADD_WALLET_BY_CUSTOMER: 'menu.addWallet.customer',
  MINI_POS: 'menu.mini.pos',
  CUSTOMER_HISTORY: 'menu.customer.history'
};
